export default "__VITE_PUBLIC_ASSET__93cd2b5d__"